import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import React from 'react'

function CustomRadio({ variant, groupName, title, colorValue, itemId, onChange, defaultValue }) {
  // console.log('title', title, 'defaultValue', defaultValue);

  return (
    <div
      className={`bs-radio ${variant === 'color'
        ? 'bs-radio--typ-color'
        : variant === 'capsule'
          ? 'bs-radio--typ-capsule'
          : ''
        }`}
    >
      <input
        type="radio"
        id={itemId}
        name={groupName}
        value={title}
        className="bs-radio__input"
        onChange={onChange}
        defaultChecked={defaultValue === title}
      />
      <label
        className="bs-radio__label"
        htmlFor={itemId}
        style={{
          background:
            variant === 'color' ? undefined : 'transparent',
        }}
      >
        {variant === 'color' ? (
          <CloudinaryAdvancedImage imagePublicId={colorValue} type="utility-icon" />
        ) : (
          title
        )}
      </label>
    </div>
  );


}

export default CustomRadio